import { FilloutSliderEmbed } from '@fillout/react'
import {
  SERVICE_REPORT_DOMAIN,
  SERVICE_REPORT_FILLOUT_ID,
  type ServiceReportParameters,
} from 'utils/serviceReportForm'

type ServiceReportEmbedProps = {
  isOpen: boolean
  onClose: () => void
  parameters: ServiceReportParameters
}

const ServiceReportEmbed = ({ isOpen, onClose, parameters }: ServiceReportEmbedProps) => {
  return (
    <FilloutSliderEmbed
      filloutId={SERVICE_REPORT_FILLOUT_ID}
      domain={SERVICE_REPORT_DOMAIN}
      parameters={parameters}
      isOpen={isOpen}
      onClose={onClose}
      sliderDirection="right"
    />
  )
}

export default ServiceReportEmbed
